export function getFileExtension(file: File): string | null {
  const fileName = file.name;
  const parts = fileName.split('.');
  if (parts.length > 1) {
    return parts.pop() ?? null; // Get the extension
  }
  return null; // Return null if there is no extension
}
